import request from '@/utils/request'

// ===== 渠道管理 =====
// 查询渠道账号余额详情（GET /ma/channel/detail）
export function queryChannelDetail(data = {}) {
  return request({
    url: '/ma/channel/detail',
    method: 'post',
    data: data
  })
}

// 查询渠道余额流水列表（POST /ma/channel/account/flow/list?pageNum=1&pageSize=10）
export function queryChannelBalanceList(urlParams, data) {
  return request({
    url: '/ma/channel/account/flow/list',
    method: 'post',
    urlParams: urlParams,
    data: data
  })
}

// 查询渠道列表
export function queryChannelList(data) {
  return request({
    url: '/ma/channel/list',
    method: 'post',
    data: data
  })
}

// ===== 商户管理 =====
// 查询商户列表
export function queryShopList(urlParams, data) {
  return request({
    url: '/ma/shop/list',
    method: 'post',
    urlParams: urlParams,
    data: data
  })
}

// 查询商户余额流水列表（POST /ma/shop/balance/flow/list）
export function queryMerchantBalanceList(urlParams, data) {
  return request({
    url: '/ma/shop/balance/flow/list',
    method: 'post',
    urlParams: urlParams,
    data: data
  })
}

// ===== 订单管理 =====
// 查询线下订单列表
export function queryOfflineList(urlParams, data) {
  return request({
    url: '/ma/order/offlineList',
    method: 'post',
    urlParams: urlParams,
    data: data
  })
}

// ===== 通用 =====
// 获取字典数据
export function getDicts(dictType) {
  return request({
    url: `/system/dict/data/type/${dictType}`,
    method: 'get'
  })
}

// ===== 彩票工具 =====
// 新增商户彩票账户
export function addLotteryAccount(data) {
  return request({
    url: '/ma/shop/lottery/account/add',
    method: 'post',
    data: data
  })
}

// 修改商户彩票账户
export function editLotteryAccount(data) {
  return request({
    url: '/ma/shop/lottery/account/edit',
    method: 'post',
    data: data
  })
}

// 查询彩票账户列表
export function queryLotteryAccountList(urlParams, data) {
  return request({
    url: '/ma/shop/lottery/account/list',
    method: 'post',
    urlParams: urlParams,
    data: data
  })
}

// 彩票账户充值/冲正
export function lotteryAccountRecharge(data) {
  return request({
    url: '/ma/shop/lottery/account/recharge',
    method: 'post',
    data: data
  })
}

// 查询彩票流水
export function queryLotteryFlowList(urlParams, data) {
  return request({
    url: '/ma/shop/lottery/flow/list',
    method: 'post',
    urlParams: urlParams,
    data: data
  })
}

// 查询彩票赠送记录
export function queryLotteryGiveList(urlParams, data) {
  return request({
    url: '/ma/shop/lottery/give/list',
    method: 'post',
    urlParams: urlParams,
    data: data
  })
}

// 查询用户彩票领取记录
export function queryUserLotteryList(urlParams, data) {
  return request({
    url: '/ma/shop/lottery/user/list',
    method: 'post',
    urlParams: urlParams,
    data: data
  })
}

// 导出用户彩票领取记录
export function exportUserLottery(data) {
  return request({
    url: '/ma/shop/lottery/user/export',
    method: 'post',
    data: data
  })
}

